import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import EmailNotifications from "../../../../../components/admin/emails/notifications/EmailNotifications";

const EmailNotificationsManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.email.notifications.admin")}>
      <EmailNotifications />
    </PageWrapper>
  );
};

export default EmailNotificationsManagement;
